


























































import Vue, { PropOptions } from 'vue';
import { mapGetters } from 'vuex';

interface Props {
  lesson: PropOptions;
}
interface LocalState {
  lessonLocal: LessonResponse | null;
}

export default Vue.extend({
  name: 'LessonEdit',
  computed: {
    ...mapGetters({
      availableQuizzes: 'quiz/quizzes',
      teacher: 'user/teacher',
    }),
    selectedQuizIsGradable() {
      if (!this.lessonLocal.quiz) return false;
      if (!this.availableQuizzes) return false;
      const selectedQuiz = this.availableQuizzes.find(
        q => q.id === this.lessonLocal.quiz
      );
      if (!selectedQuiz) return false;

      return selectedQuiz.is_gradable;
    },
  },
  data(): LocalState {
    return {
      lessonLocal: null,
    };
  },
  props: {
    lesson: {
      type: Object as () => LessonResponse,
      default: null,
    },
  } as Props,
  methods: {
    async remove(): Promise<void> {
      this.$emit('remove', this.lesson);
    },
  },
  watch: {
    lessonLocal: {
      handler(lessonLocal, oldLessonLocal) {
        if (lessonLocal?.id === oldLessonLocal?.id) {
          // Changing lesson data
          this.$set(this.lessonLocal, 'isDirty', true);
        }
      },
      deep: true,
    },
    lesson: {
      immediate: true,
      handler(lesson) {
        this.lessonLocal = lesson;
      },
    },
  },
});
